import styled from 'styled-components'
import {airBlue} from '@modifi/colors'

export const Capitalize = styled.span`
  text-transform: capitalize;
`

export const NameTag = styled.div`
  border-radius: 15px;
  background-color: ${({color}) => color || airBlue};
  padding: 0 15px;
  margin: 5px 5px 0 0;
  display: inline-block;
`
